import { EntityDefinition } from "ips/ac/model/types/EntityDefinition";

const OrderLabelDefinition: EntityDefinition = {
  ENTITY: "OrderLabel",
  ENTITY_SET: "OrderLabels",
  DETAIL: "OrderLabelDetails",
};
export default OrderLabelDefinition;
